import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FetchTestBarcode } from "../../redux/features/barcode/barcodeAction";
import Barcode from "react-barcode";
import "./style.css";

const TestBarcodePage = () => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const [testBarcode, setTestBarcode] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);


  useEffect(() => {
    const fetchTestBarcode = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          navigate("/auth");
          return;
        }

        const response = await dispatch(FetchTestBarcode());
        if (response?.payload?.data?.barcode) {
          console.log("Fetched Test Barcode:", response.payload.data.barcode);
          setTestBarcode(response.payload.data.barcode);
        } else {
          console.error("No barcode received from API.");
        }
      } catch (error) {
        console.error("Failed to fetch barcode:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTestBarcode();
  }, [dispatch, navigate]);

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h3 className="text-2xl mb-4">Scansiona il codice a barre di prova</h3>

      {loading ? (
        <p>Caricamento in corso...</p>
      ) : testBarcode ? (
        <div className="barcodeDiv">
          <Barcode value={testBarcode} format="CODE128" displayValue={false} />
        </div>
      ) : (
        <p>No barcode available</p>
      )}
    </div>
  );
};

export default TestBarcodePage;
